import { Switch } from "@headlessui/react";
import { ReactComponent as Tick } from "../../../assets/images/icons/Tick.svg";
import { ReactComponent as Close } from "../../../assets/images/sidebar/Times.svg";

const Toggle = ({ enabled, setEnabled }: any) => {
    return (
        <Switch.Group>
            <div className="flex items-center">
                <Switch
                    checked={enabled}
                    onChange={setEnabled}
                    className={`${enabled ? "bg-primary-600 hover:!bg-primary-800" : "bg-secondary-300 hover:!bg-[#A0A3BD]"} relative inline-flex h-[24px] w-[40px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className={`${enabled ? "translate-x-0" : "-translate-x-4"} pointer-events-none  mt-[1px] inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                    >
                        {enabled ? (
                            <Tick fill="#2991FF" width={10} height={10} className="mx-auto mt-[5px]" />
                        ) : (
                            <Close fill="#D9DBE9" width={10} height={10} className="mx-auto mt-[4px]" />
                        )}
                    </span>
                </Switch>
                <Switch.Label className="mr-4 text-[14px] my-6 font-medium">دانلود نامحدود</Switch.Label>
            </div>
        </Switch.Group>
    );
};

export default Toggle;
